import R from "ramda";
import { browserHistory } from "react-router";
import { store } from "store";
import {
  addIncludeRule,
  deleteIncludeRule,
  putDocument,
  exportSelected,
  exportAll
} from "api/documents";
import { setFlashMessageAction } from "actions/app-actions";
import { reloadDocuments, endExportModeAction } from "actions/documents-actions";
import { trackEventAction } from "actions/shared/tracking-actions";
import { splitCategories, doesCategoryStartWithGlPrefix } from "utils/split-categories";

export const SPLIT_CATEGORIES = "actions/documents/exports/split-categories";
export const SET_GL_CODE = "actions/documents/exports/set-gl-code";
export const ADD_INCLUDE_RULE = "actions/documents/exports/add-include-rule";
export const REMOVE_INCLUDE_RULE = "actions/documents/exports/remove-include-rule";
export const SET_VIEWED_DOCUMENT_URL = "actions/documents/exports/set-viewed-document-url";

export const splitCategoriesAction = (categories) => {
  const { glCodes, newCategories, trackingCodes } = splitCategories(categories);
  const strippedGlCodes = glCodes.map(category => {
    const newCategory = R.clone(category);
    const newName = R.drop(1, category.name.split("-")).join("-");
    newCategory.newName = newName;
    return newCategory;
  });
  return {
    type: SPLIT_CATEGORIES,
    data: { strippedGlCodes, newCategories, trackingCodes }
  };
};

export const setGlCodeAction = (document, glCode) => (dispatch) => {
  const newDocument = R.clone(document);
  if (!newDocument.categories) {
    newDocument.categories = [];
  }
  if (glCode.key === "clear-category") {
    const nonGLCategories = document.categories.filter((category) => (
      !doesCategoryStartWithGlPrefix({ name: category }))
    );
    newDocument.categories = nonGLCategories;
    dispatch({
      type: SET_GL_CODE,
      data: { document: newDocument }
    });
    return putDocument(document.accountId, document.id, newDocument);
  }
  const prefix = glCode.key.split("-").shift();
  const index = newDocument.categories.findIndex(code => code.indexOf(prefix) > -1);
  if (index > -1) {
    newDocument.categories.splice(index, 1, glCode.key);
  } else {
    newDocument.categories.push(glCode.key);
  }
  dispatch({
    type: SET_GL_CODE,
    data: { document: newDocument }
  });
  dispatch(trackEventAction("GL code added to document"));
  return putDocument(document.accountId, document.id, newDocument);
};

export const addIncludeRuleAction = (data) => (dispatch) => {
  const state = store.getState();
  const categories = state.categories.categories;
  const categoryId = R.find(R.propEq("name", data.glCode.name))(categories).id;
  const rule = {
    action: "include",
    vendorName: data.vendorName
  };
  dispatch({
    type: ADD_INCLUDE_RULE
  });
  dispatch(trackEventAction("Include rule added to document"));
  return addIncludeRule(data.accountId, categoryId, rule)
    .then(() => {
      dispatch(setFlashMessageAction("Rule created"));
    });
};

export const removeIncludeRuleAction = (data) => (dispatch) => {
  const { accountId, categoryId, ruleId } = data;
  deleteIncludeRule(accountId, categoryId, ruleId)
    .then(() => {
      dispatch({
        type: REMOVE_INCLUDE_RULE,
        data: { categoryId, ruleId }
      });
      dispatch(setFlashMessageAction("Rule removed", "error"));
      dispatch(trackEventAction("Include rule removed from document"));
    });
};

export const setViewedDocumentUrlAction = (url) => ({
  type: SET_VIEWED_DOCUMENT_URL,
  data: url
});

export const addRuleErrorAction = () =>
  setFlashMessageAction("Please add a GL code before adding a rule", "error");


export const exportSelectedAction = (accountId, selectedDocumentIds) => (dispatch) => (
  exportSelected(accountId, selectedDocumentIds)
    .then(() => {
      dispatch(endExportModeAction());
      dispatch(setFlashMessageAction("Documents queued for export."));
      dispatch(trackEventAction("Export selected"));
    })
    .then(() => reloadDocuments(dispatch))
);

export const exportAllAction = (accountId) => (dispatch) => (
  exportAll(accountId)
    .then(() => {
      dispatch(endExportModeAction());
      dispatch(setFlashMessageAction("Documents queued for export."));
      dispatch(trackEventAction("Export all"));
    })
    .then(() => reloadDocuments(dispatch))
);

export const linkAccountAction = (accountSlug) => {
  browserHistory.push(`/accounts/${accountSlug}/settings/integration`);
  return {
    type: "NOOP"
  };
};



// WEBPACK FOOTER //
// ./src/js/actions/exports-actions.js